<div class="sp-width__full sp-grid__summary-3 sp-grid__gap sp-overflow__x-scroll">
  <app-shared-summary-item
    [item_label]="'SELLERS.SUMMARY_ALL_LABEL'"
    [item_value]="summary?.length?.toString() || '0'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'SELLERS.SUMMARY_PENDING_LABEL'"
    [item_value]="summary?.not_confirmed?.toString() || '0'"
    [item_class]="'sp-background__status-500'"
    [label_class]="'sp-color__primary'"
    [value_class]="'sp-color__primary'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
  <app-shared-summary-item
    [item_label]="'SELLERS.SUMMARY_CONFIRMED_LABEL'"
    [item_value]="summary?.confirmed?.toString() || '0'"
    [item_class]="'sp-background__accent'"
    [label_class]="'sp-color__accent-contrast'"
    [value_class]="'sp-color__accent-contrast'"
    [is_summary_request_running]="is_summary_request_running"></app-shared-summary-item>
</div>
